import PropTypes from 'prop-types';
import classNames from 'classnames';

import './StarRating.scss';
import { ReactComponent as Star } from '../../assets/svg/star.svg';

const baseClassName = 'star-rating';
export default function StarRating({ title, value, max }) {
	const stars = Array.from({ length: max }, (_, i) =>
		i + 1 <= value ? 'on' : i + 1 - value < 1 ? 'half' : 'off',
	);
	// console.warn(stars);

	return (
		<div className={baseClassName}>
			{title && (
				<header className={`${baseClassName}__title`}>{title}</header>
			)}
			<div className={`${baseClassName}__wrapper`}>
				<div className={`${baseClassName}__stars`}>
					{stars.map((classNameSuffix, i) => (
						<Star
							key={`star-${i}`}
							className={classNames([
								`${baseClassName}__star`,
								`${baseClassName}__star--${classNameSuffix}`,
							])}
						></Star>
					))}
				</div>
				<div className={`${baseClassName}__rating`}>
					{value}/{max}
				</div>
			</div>
		</div>
	);
}

StarRating.propTypes = {
	value: PropTypes.number,
	max: PropTypes.number,
};
